<template>
  <div>
    <div>Team: {{team.name}}</div>
    <div>Domain: {{team.domain}}</div>
    <div v-if="team.company_size">Company Size: {{team.company_size}}</div>
    <div v-if="team.have_design">Have Design? {{team.have_design}}</div>
    <div v-if="defaultRestrictions.length > 0" class="default-restrictions">
      Default Member Restrictions:
      <div v-for="restriction in defaultRestrictions" :key="restriction"><i style="vertical-align: 10%; margin-right: 1em;" class="fas fa-lock fa-xs"/>{{restriction}}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.default-restrictions {
  margin-top: 0.5em;
  div {
    font-size: smaller;
  }
}
</style>


<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters(['team', 'productTemplates']),
    defaultRestrictions() {
      // Return list of default orderer restrictions.
      let result = [], s = this.team.default_orderer_settings || {};
      if (s.restrictDesign) {
        let pt = this.productTemplates.find(pt => pt.id === s.current_producttemplate);
        result.push(`Restrict design to ${pt ? pt.name : '(template not found)'}`);
      }
      if (s.restrictQty) {
        result.push('Restrict changing qty');
      }
      if (s.restrictProduct) {
        result.push('Restrict changing paper');
      }
      return result;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewTeam.vue